














































































































import BaseComponent from '@/core/base.component';
import { Component, Prop } from 'vue-property-decorator';
import { CompanyDto } from '@/dto/company/company.dto';
import { BaseUser } from '../../../services/shared/auth';
import companyService from '../../../services/company.service';
import fileUploadService, {
  UPLOAD_TYPE,
} from '../../../services/shared/file-upload/file-upload.service';
import {
  FileAttachmentDto,
  ATTACHMENT_REASON_TYPE,
} from '../../../services/shared/file-upload';
import ApprovalStatusChangeInfoText from '@/modules/_common/components/info-text/ApprovalStatusChangeInfoText.vue';
import jwtStorageService from '@/services/shared/auth/jwt-storage.service';
import companyUserService from '../../../services/company-user.service';
@Component({
  name: 'CompanyChangeDialog',
  components: { ApprovalStatusChangeInfoText },
})
export default class CompanyChangeDialog extends BaseComponent {
  private companyDto = new CompanyDto();
  private loading = false;
  private logoChanged = false;
  private logo: FileAttachmentDto[] = [];
  private originalCompanyDto = {};
  @Prop() readonly dialog: boolean;

  get isInputChanged() {
    // dto가 원래데이터와 다르면 true return else return false
    if (
      JSON.stringify(this.originalCompanyDto) == JSON.stringify(this.companyDto)
    ) {
      return false;
    } else {
      return true;
    }
  }

  reset() {
    // this.userAddDialog = false;
    this.$emit('update:dialog', !this.dialog);
    this.loading = false;
    this.logo = [];
    this.logoChanged = false;
    this.getCompanyInfo();
  }

  getCompanyInfo() {
    companyService.findOne().subscribe(res => {
      this.companyDto = res.data;
      this.originalCompanyDto = { ...this.companyDto };
    });
  }

  async upload(event: File) {
    const attachments = await fileUploadService.upload(
      UPLOAD_TYPE.COMPANY_LOGO,
      [event],
    );
    this.logo.push(
      ...attachments.filter(
        fileUpload =>
          fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
      ),
    );
    this.logoChanged = true;
  }

  requestChange() {
    if (this.logo && this.logo.length > 0) {
      this.companyDto.logo = this.logo;
    } else {
      delete this.companyDto.logo;
    }
    this.loading = true;
    companyService.change(this.companyDto).subscribe(res => {
      if (res) {
        companyUserService.getTokenById().subscribe(res => {
          this.loading = false;
          jwtStorageService.setToken(res.data.token);
          this.reset();
          this.$emit('requested');
          this.$toasted.global.custom_success({
            message: '정보 변경 신청 성공!',
          });
        });
      } else {
        this.loading = false;
      }
    });
  }

  created() {
    this.getCompanyInfo();
  }
}
